// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U0Gb","col":"styles_col__3ic1q","actions":"styles_actions__2vaHN","conflict":"styles_conflict__3HnNk"};